import { render, staticRenderFns } from "./VGenderSelect.vue?vue&type=template&id=201fc51a"
import script from "./VGenderSelect.vue?vue&type=script&lang=js"
export * from "./VGenderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports